import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-tool-markup",
  "use": "svg_i-tool-markup-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"svg_i-tool-markup\"><path d=\"M4.987 5.015h6.017V0H2.316A2.318 2.318 0 0 0 0 2.318v8.716h4.987V5.015zM25.01 25.03h-6.002v4.969h8.662a2.318 2.318 0 0 0 2.316-2.318v-8.676H25.01v6.025zm-20.012-.02.02-6.008H0v8.668a2.318 2.318 0 0 0 2.318 2.316h8.677V25.01H4.998zM18.984 0v5.008h6.063v6.024H30V2.318A2.318 2.318 0 0 0 27.684 0h-8.7zM10 20h10V10H10z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol